// -----------------------------------------------------------------------------
// This file was copied from packages/shared/bop-view-definitions/src by scripts/sync-bop-view-definitions.sh.
// Do not edit this copied version directly.
// It is generated by the sync script and will be overwritten.
// -----------------------------------------------------------------------------

export enum InvoiceColumns {
    CUSTOMER_ID = 'customerId',
    CUSTOMER_NO = 'customerNo',
    INVOICE_NUMBER = 'invoiceNo',
    CLIENT_ID = 'clientId',
    CLIENT_NAME = 'clientName',
    CLIENT_LOGO = 'clientLogo',
    READABLE_CLIENT_ID = 'readableClientId',
    CUSTOMER_NAME = 'customerName',
    COUNTRY = 'countryCode',
    DUE_DATE = 'dueDate',
    INVOICE_DATE = 'invoiceDate',
    TOTAL_REMAINING_BALANCE = 'remainingAmount',
    STAGE = 'stage',
    STATUS = 'status',
    PAYMENT_STATUS = 'paymentStatus',
    SERVICE_LINE_ID = 'serviceLineId',
    VAT_AMOUNT = 'vatAmount',
    PAYMENT_REFERENCE = 'paymentReference',
    CURRENCY = 'currency',
    PDF_LINK = 'pdfURL',
    // New Fields
    SERVICE_LINE_NAME = 'serviceLineName',
    FEE = 'fee',
    ORIGINAL_TOTAL_AMOUNT = 'originalTotalAmount',
    PAYMENT_METHOD = 'paymentMethod',
    PAYMENT_DATE = 'paymentDate',
    lAST_ESCALATION_DATE = 'lastEscalationDate',
    WHEN_ESCALATING_TO_DEBT_COLLECTION = 'whenEscalatingToDebtCollection',
    PAID_AMOUNT = 'paidAmount',
    DAYS_OVERDUE = 'daysOverdue',
    ORG_NO = 'orgNo',
    DISTRIBUTION_CHANNEL = 'distributionChannel',
    REMINDER_DATE = 'reminderDate',
    // Paused columns
    PAUSED_TYPE = 'pausedType',
    PAUSED_LEVEL = 'pausedLevel',
    PAUSED_DURATION = 'pausedDuration',
}

export const DEFAULT_INVOICE_COLUMNS = [
    InvoiceColumns.CUSTOMER_ID,
    InvoiceColumns.INVOICE_NUMBER,
    InvoiceColumns.INVOICE_DATE,
    InvoiceColumns.DUE_DATE,
    InvoiceColumns.ORIGINAL_TOTAL_AMOUNT,
    InvoiceColumns.TOTAL_REMAINING_BALANCE,
    InvoiceColumns.STAGE,
    InvoiceColumns.STATUS,
    InvoiceColumns.PAYMENT_STATUS,
    InvoiceColumns.CUSTOMER_NAME,
    InvoiceColumns.CUSTOMER_NO,
] as const satisfies readonly InvoiceColumns[];

export const MANDATORY_INVOICE_COLUMNS = [
    InvoiceColumns.CUSTOMER_ID,
    InvoiceColumns.CUSTOMER_NO,
    InvoiceColumns.CUSTOMER_NAME,
    InvoiceColumns.INVOICE_NUMBER,
] as const satisfies readonly InvoiceColumns[];

/**
 * The customer profile invoice list draws from the same `InvoiceColumns` set, but is
 * persisted under its own table name so it can be configured independently from the
 * main invoices grid.
 *
 * The customer identity columns (customerId, customerNo, customerName) are
 * deliberately absent: the profile page already scopes every row to one customer,
 * so repeating that per row adds nothing. They remain selectable, just not shown
 * by default.
 */
export const DEFAULT_CUSTOMER_INVOICE_COLUMNS = [
    InvoiceColumns.INVOICE_NUMBER,
    InvoiceColumns.INVOICE_DATE,
    InvoiceColumns.DUE_DATE,
    InvoiceColumns.ORIGINAL_TOTAL_AMOUNT,
    InvoiceColumns.TOTAL_REMAINING_BALANCE,
    InvoiceColumns.STAGE,
    InvoiceColumns.STATUS,
    InvoiceColumns.PAYMENT_STATUS,
] as const satisfies readonly InvoiceColumns[];

export const MANDATORY_CUSTOMER_INVOICE_COLUMNS = [InvoiceColumns.INVOICE_NUMBER] as const satisfies readonly InvoiceColumns[];
